// ----------------------------------------------------------------------
// <copyright file="Izenda.ChangePasswordPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {

  'use strict';

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Input = require('share/components/controls/Izenda.Input');
  var ValidatableInput = Validator()(Input);
  var AccountConstants = require('logic/data/Izenda.AccountConstants');
  var actions = require('./Izenda.ChangePasswordPopupActions');
  var ObservablePropTypes = require('mobx-react').propTypes;
  var MyProfileAlert = require('../Toolbar/Izenda.MyProfileAlert');

  var ChangePasswordPopup = React.createClass({
    propTypes: {
      store: ObservablePropTypes.observableObject.isRequired
    },

    componentWillMount: function(){
      this.props.store.model.resetValidation();
    },

    /**
     * Render component
     */
    render: function() {
      var localization = this.props.localization;

      return (
        <Popup visible
               onClosing={this.props.onClosing}
               autoClose={false}
               type='none'
               sizeClass='modal-xs'>
          <Popup.Header title={localization.getText('COMMON_LABEL_CHANGE_PASSWORD')} />
          <Popup.Body>
            <MyProfileAlert alertMessage={this.props.store.model.alertMessage}></MyProfileAlert>
            <GridLayout>
              <GridLayout.Row>
                <GridLayout.Col cols='4'>
                  <label className='validation required u_controlHeight control-label'>
                    {localization.getText('COMMON_LABEL_CURRENT_PASSWORD')}
                  </label>
                </GridLayout.Col>
                <GridLayout.Col cols='8'>
                  <ValidatableInput field='currentPassword'
                                    type='password'
                                    className='form-control'
                                    value={this.props.currentPassword}
                                    validations={AccountConstants.CONSTRAINTS.currentPassword}
                                    onChange={this.props.updateCurrentPassword} />
                </GridLayout.Col>
              </GridLayout.Row>
              <GridLayout.Row>
                <GridLayout.Col cols='4'>
                  <label className='validation required u_controlHeight control-label'>
                    {localization.getText('ACOUNT_LABEL_NEW_PASSWORD')}
                  </label>
                </GridLayout.Col>
                <GridLayout.Col cols='8'>
                  <ValidatableInput field='password'
                                    type='password'
                                    className='form-control'
                                    value={this.props.newPassword}
                                    validations={AccountConstants.CONSTRAINTS.password}
                                    onChange={this.props.updateNewPassword} />
                </GridLayout.Col>
              </GridLayout.Row>
              <GridLayout.Row>
                <GridLayout.Col cols='4'>
                  <label className='validation required u_controlHeight control-label'>
                    {localization.getText('ACOUNT_LABEL_CONFIRM_NEW_PASSWORD')}
                  </label>
                </GridLayout.Col>
                <GridLayout.Col cols='8'>
                  <ValidatableInput field='confirmPassword'
                                    type='password'
                                    className='form-control'
                                    value={this.props.confirmNewPassword}
                                    validations={AccountConstants.CONSTRAINTS.confirmPassword}
                                    onChange={this.props.updateConfirmNewPassword} />
                </GridLayout.Col>
              </GridLayout.Row>
          </GridLayout>
          </Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type='accept'>{localization.getText('COMMON_LABEL_SAVE')}</Popup.ConfirmationButton>
            <Popup.ConfirmationButton type='cancel'>{localization.getText('COMMON_LABEL_CANCEL')}</Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );
    }
  });

  module.exports = connect(actions)(ChangePasswordPopup);
}());



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/SecurityOptions/Izenda.ChangePasswordPopup.jsx